import { dictionaryNameById } from '../constants/dictionaryNameById';
import { DictionaryUUIDsEnum } from '../enums/DictionaryUUIDsEnum';

export const getDictionariesItemValueKey = (dictionaryUUID: DictionaryUUIDsEnum) => dictionaryNameById[dictionaryUUID];
